
import { Gallery } from '../widget/gallery.js';

(function($){

    var $controller  = {

        options: {
            pushState: false
        },

        image: null,
        collection: [],

        position: 0,

        history: {},

        template: {
            modal: require('../views/modal.js')
        },

        modal: null,

        init: function() {
            this.process();
            this.listen();
        },
        
        process: function() {
            if(this.shouldProcess($('body'))) {
                $('.page-template-default .page-content img, .entry-content img,.gallery--post img').each(function() {
                    var $this = $(this);
                    if($controller.shouldProcess($this)) {
                        $this.addClass('galleryify--ready');
                    }
                });
            }
        },

        shouldProcess: function($el) {
            return !$el.hasClass('template--gallery__page');
        },

        listen: function() {
            $('.galleryify--ready').click(function($evt) {
                $evt.preventDefault();
                $controller.open(this);
            });
            $(document).on('gallery--close', function($evt) {
                $controller.close();
            });
        },

        open: function(image) {
            this.takeSnapshot();
            this.attach(image);
            this.build();
            this.run();
            this.pushState();
        },

        close: function() {
            this.modal && this.modal.remove();
            $('body').removeClass('gallery-modal__open');
            this.resetPushState();
        },

        takeSnapshot: function() {
            this.history = {
                url: window.location.href,
            };
            return this;
        },

        attach: function(image) {
            this.image = $(image);
            this.collection = $('.galleryify--ready');
            this.total = this.collection.length;
            this.position = this.collection.index(this.image);
            return this;
        },

        getCaption: function() {
            return this.image.data('caption') ? this.image.data('caption') : '';
        },

        buildCounter: function() {
            return (this.position + 1) + '/' + this.total;
        },

        buildImageHtml: function() {
            var $html = [];
            this.collection.each(function() {
                var $this = $(this);
                if($this.data('size-lg')) {
                    $this = $this.clone().attr('src', $this.data('size-lg'));
                }
                $html.push($this.get(0).outerHTML);
            });
            return $html.join("\n");
        },

        build: function() {
            var $data = {
                caption: this.getCaption(),
                counter: this.buildCounter(),
                image_html: this.buildImageHtml(),
                photo_credit_text: this.image.data('photo_credit') ? this.image.data('photo_credit') : '',
                photo_credit_link: this.image.data('photo_credit_link') ? this.image.data('photo_credit_link') : ''
            };
            this.modal = $(this.template.modal($data));
            $('body').append(this.modal).addClass('gallery-modal__open');
        },

        run: function() {
            new Gallery({
                context: 'modal',
                checkMargin: true,
                container: this.modal,
                position: this.position,
                history: this.history
            });
        },

        pushState: function() {
            if(this.options.pushState) {
                this.image.data('permalink') 
                    && history 
                    && history.pushState 
                    && history.pushState(
                        {position: this.position, history: this.history}, 
                        'Gallery :: Attachment #'+this.position, 
                        this.image.data('permalink')+'#'+this.position
                    );
            }
            return this;
        },

        resetPushState: function() {
            if(this.options.pushState) {
                history
                    && history.pushState
                        && this.history.url
                            history.pushState(
                                {},
                                'Post',
                                this.history.url
                            );
            }
            return this;
        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/galleryify.js